import constants from '../constants.json';

export const myFlipdish = (appId = '', preventCache?: boolean) => {
  return `${constants.PANACEA_URL}/${appId}${preventCache ? `?touch=${Date.now()}` : ''}`;
};
